import {RESERVED_WORKSPACE_PATH_SEGMENTS} from "~/workspaceConfig/configPageRoutes";

export type FixedArgusPageContext = {
    pageName: string;
    pageType: string;
};

const FIXED_WORKSPACE_PAGE_NAMES: Record<string, string> = {
    ottopilot: "Ottopilot",
    ottokart: "Ottokart",
    ottosync: "Ottosync",
    test: "Test",
    "account-settings": "Account Settings",
    billing: "Billing",
    collections: "Collections",
    dashboard: "Dashboard",
    bluestores: "Blue Stores",
    "favourite-reports": "Favourite Reports",
    koios: "Koios",
    notifications: "Notifications",
    "organizational-unit-templates": "Organizational Unit Templates",
    "organizational-units": "Organizational Units",
    "product-catalogue-templates": "Product Catalogue Templates",
    "product-inventories": "Product Inventories",
    products: "Products",
    profile: "Profile",
    reports: "Reports",
    "store-configuration": "Store Configuration",
    "user-invitation": "User Invitation",
    "user-templates": "User Templates",
    users: "Users",
};

/**
 * Human-readable page name for non-config routes (ottosync, reports, account-settings, …).
 * Returns null for config page UUID paths so `$pageKey` beforeLoad can set `page.title`.
 */
export function resolveFixedArgusPageContext(pathname: string): FixedArgusPageContext | null {
    if (pathname === "/u/select-workspace" || pathname.startsWith("/u/select-workspace/") === true) {
        return {
            pageName: "Select Workspace",
            pageType: "SelectWorkspace",
        };
    }
    if (pathname === "/account-settings" || pathname.startsWith("/account-settings/") === true) {
        return {
            pageName: "Account Settings",
            pageType: "AccountSettings",
        };
    }

    const workspaceMatch = pathname.match(/^\/w\/[^/]+\/([^/]+)/);
    if (workspaceMatch === null || workspaceMatch[1] === undefined) {
        return null;
    }
    const segment = workspaceMatch[1];
    if (RESERVED_WORKSPACE_PATH_SEGMENTS.has(segment) !== true) {
        return null;
    }
    const pageName = FIXED_WORKSPACE_PAGE_NAMES[segment];
    if (pageName === undefined) {
        return {
            pageName: segment,
            pageType: segment,
        };
    }
    return {
        pageName: pageName,
        pageType: segment,
    };
}
